import { createFileRoute } from "@tanstack/react-router";
import { providerOutreachHandoffOpenedRoute } from "@/app-clients/provider-outreach-flow";

export const Route = createFileRoute(
    "/api/kits/contact-sessions/$sessionId/handoff-opened",
)({
    ...providerOutreachHandoffOpenedRoute,
});
